import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import styled from 'styled-components';
import { Like } from 'styled-icons/boxicons-solid';
import ReactQuill from 'react-quill';
import { palette } from '../../../system/styles/styles';

const PostPreview = ({ data, open, handleClose, className }) => {
  const HandleClose = () => {
    handleClose((prevState) => ({
      ...prevState,
      showPreview: false,
    }));
  };

  if (!open) return null;

  return (
    <Dialog onClick={HandleClose}>
      <div className={className}>
        <div
          className="imageArea"
          style={{
            backgroundImage:
              data.img === ''
                ? `linear-gradient(rgba(255,255,255,.75),rgba(255,255,255,.75)), url(https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2FNoImage.svg?alt=media&token=620e3473-8b5d-4a4c-8efc-96ec3a13015c) center / contain`
                : `linear-gradient(rgba(255,255,255,.75),rgba(255,255,255,.75)), url(https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2FNoImage.svg?alt=media&token=620e3473-8b5d-4a4c-8efc-96ec3a13015c) center / cover`,
            backgroundSize: data.img === '' ? 'contain' : 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}>
          <p className="postTitlePreview">{data.postTitle}</p>
        </div>
        <div className="descriptionArea">
          <div className="textContainer">
            <ReactQuill className="postEditor" value={data.editorData} readOnly theme="snow" />
          </div>
          <div className="favoriteArea">
            <button className="addFavorite">
              Me gusta
              <Like className="favIconCheked" size={20} />
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default styled(PostPreview)`
  width: 75%;
  padding: 0px;
  display: flex;
  background-color: #f9f9f9;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  font-family: futura-pt;
  flex-direction: row;
  @media screen and (max-width: 900px) {
    padding: 10px;
    align-items: center;
    width: 100%;
  }
  .imageArea {
    width: 100%;
    padding: 0px;
    margin: 0px;
    background-repeat: no-repeat;
    height: 25vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 20px;
  }
  .postTitlePreview {
    color: ${palette.black};
    font-size: 2.1rem;
    font-weight: 400;
  }
  .descriptionArea {
    width: 100%;
    display: flex;
    justifycontent: space-between;
    @media screen and (max-width: 900px) {
      flex-wrap: wrap;
    }
  }
  .textContainer {
    width: 57.5%;
    @media screen and (max-width: 980px) {
      width: 100%;
    }
  }
  .postEditor {
    width: 100%;
    fontsize: 1.7rem !important;
    color: ${palette.black};
    h1,
    h2,
    h3,
    h4,
    h5 {
      color: ${palette.black};
    }
  }
  .favoriteArea {
    width: 30%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    height: min-content;
    padding: 10px;
    @media screen and (max-width: 980px) {
      width: 100%;
    }
  }
  .addFavorite {
    fontsize: 1.7rem;
    color: ${palette.blue};
    border: solid 1px ${palette.blue};
    padding: 7px 0px;
    width: 60%;
    height: min-content;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: ${palette.white};
  }
  .favIconCheked {
    fontsize: 2.75rem;
    margin: 0px;
    color: ${palette.blue};
    @media screen and (max-width: 980px) {
      font-size: 2.5rem;
    }
    @media screen and (max-width: 980px) {
      font-size: 2.2rem;
    }
  }
`;
